import { pick } from 'lodash';
import React, { useState } from 'react';

import type { IViewModelProps } from 'controller/types';

import { ControllerContext } from './ControllerContext';

interface IProps extends IViewModelProps {
  children: React.ReactNode;
}

export function ControllerProvider(props: IProps) {
  const { children } = props;

  const [value] = useState(
    pick(
      props,
      'application$',
      'verticals$',
      'centralFeed$',
      'events$',
      'comments$',
      'feed$',
      'files$',
      'group$',
      'groups$',
      'media$',
      'members$',
      'topics$',
      'search$',
      'groupRequests$',
      'pricingPlans$',
    ),
  );

  return (
    <ControllerContext.Provider value={value}>
      {children}
    </ControllerContext.Provider>
  );
}

ControllerProvider.displayName = 'ControllerProvider';

export function useController() {
  return React.useContext(ControllerContext);
}
